<template>
    <CompassEmptyState
        v-if="hasActiveFilters"
        illustrationPath="/ressources/logged/img/illustrations/no-results.svg"
        :title="$t.__('objectives.listing.ObjectivesListing.no_result')"
        :caption="$t.__('objectives.listing.ObjectivesListing.try_reset_filters')"
    >
        <CompassButton :label="$t.__('common.actions.reset')" @click="handleResetFilters" />
    </CompassEmptyState>

    <CompassEmptyState
        v-else
        illustrationPath="/ressources/logged/img/illustrations/empty-objectives.svg"
        :title="$t.__('objectives.listing.ObjectivesListing.maximise_objectives')"
        :caption="$t.__('objectives.listing.ObjectivesListing.add_first_objective')"
    >
        <CompassTooltip :disabled="!buttonConfig.disabled" :content="buttonConfig.tooltip">
            <CompassButton
                :label="buttonConfig.label"
                :disabled="buttonConfig.disabled"
                :data-bot="buttonConfig.dataBot"
                @click="
                    $router.push({
                        path: buttonConfig.callback,
                        params: {},
                    })
                "
            />
        </CompassTooltip>
    </CompassEmptyState>
</template>

<script>
export default {
    props: {
        hasActiveFilters: {
            type: Boolean,
            required: true,
        },
        buttonConfig: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleResetFilters() {
            this.$emit('reset-filters');
        },
    },
};
</script>
